<script setup lang="ts">
  import { route } from '@procommerce/visitor';

  defineOptions({
    layout: ['StoreLayout', 'AccountLayout'],
    inheritAttrs: false,
  });

  defineProps({
    offer: { type: Object, required: true },
    quotation: { type: Object, required: true },
  });
</script>
<template>
  <AccountMobileNavigation :href="route('web.account.offers.show', { offer: offer.id })">
    {{ $t('Oferta Nr #:nr', { nr: quotation.id }) }}
  </AccountMobileNavigation>

  <OfferQuotationView :offer="offer" :quotation="quotation" />
</template>
